module.exports = __webpack_public_path__ + "static/lights29-2443dcbc950fc32b14f5dbc80142353a.jpg";